import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Subject, of } from 'rxjs';
import { catchError, filter, map, takeUntil, tap } from 'rxjs/operators';
import { DataService } from 'src/app/_helpers';
import { NotificationTemplate } from 'src/app/_models';
import { CustomerService, TemplateService } from 'src/app/_services';
import { validateNoPreSelect } from 'src/app/invoices/form-validators/partial-payment-validator';
import { checkIcon, frownIcon, icons } from 'src/app/sharedcomp/constans/icons.constans';

@Component({
  selector: 'app-create-template-form',
  templateUrl: './create-template-form.component.html',
  styleUrls: [
    './create-template-form.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../../assets/css/new-form-elements.css'
  ]
})
export class CreateTemplateFormComponent implements OnInit {
  tags: any[] = [];

  private customerPublicId: string;
  notificationType: any[] = [];

  public createTemplateForm: FormGroup;
  htmlEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    placeholder: 'Texto aqui...',
    translate: 'no',
    uploadUrl: 'v1/images', // if needed
    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  updateSucess: boolean = false;
  updateError: boolean = false;
  isSubmitButtonDisabled: boolean = false;

  icons: Record<string, { path: string; alt: string }>;
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private templateService: TemplateService,
    private customerService: CustomerService,
    private dataService: DataService
  ) {
    this.initCreateTemplateForm();
    this.icons = this.setIcons();
  }

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == undefined || browserStorage == '') {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = browserStorage;
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }
    this.createTemplateForm.get('customer.public_id').setValue(this.customerPublicId);
    this.getTemplateType();
    this.getTagsApi();
  }

  ngOnDestroy(): void {
    this.customerService.templateNotificationId = '';
    this.customerService.templateNotificationFormType = '';
    this.destroy$.next();
    this.destroy$.complete();
  }

  setIcons() {
    return {
      frown: frownIcon,
      check: checkIcon
    };
  }

  goToList(componentType: 'LIST') {
    this.dataService.displayTemplateSection(componentType);
  }

  setTemplateStatus(event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.createTemplateForm.get('status').setValue(checked ? 'ACTIVE' : 'INACTIVE');
  }

  getTemplateType() {
    this.templateService.getTemplateType(this.customerPublicId)
      .pipe(
        takeUntil(this.destroy$),
        map(data => data.values.channels.filter(item => item.active === true && item.id !== 'WHATSAPP')),
        map(filteredItems => filteredItems.map(item => item.id)),
        tap(ids => {
          this.notificationType = ids;
        }),
        catchError(error => {
          console.error('Failed while trying to get template type.' + error);
          return of(null);
        })
      )
      .subscribe();
  }

  initCreateTemplateForm() {
    this.createTemplateForm = this.formBuilder.group({
      name: new FormControl("", [Validators.required]),
      header: new FormControl("", [Validators.required]),
      type: new FormControl("Seleccione", [Validators.required, validateNoPreSelect]),
      status: new FormControl("INACTIVE"),
      content: new FormControl("", [Validators.required]),
      customer: this.formBuilder.group({
        public_id: new FormControl('')
      })
    });
  }

  setType(event) {}

  onsubmit({ value }: { value: NotificationTemplate }) {
    this.dataService.loadSpinner(true);
    this.updateError = false;
    this.updateSucess = false;
    this.customerService.createNotificationTemplate(this.customerPublicId, value)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          this.isSubmitButtonDisabled = true;
          this.updateSucess = true;
          this.dataService.loadSpinner(false);
        }),
        catchError(error => {
          this.dataService.loadSpinner(false);
          this.updateError = true;
          return of(null);
        })
      )
      .subscribe();
  }
  getTagsApi(){
    this.templateService.getTags().subscribe((data) => {
      this.tags=[
      {label: data[0].name, id: data[0].value},
      {label: data[1].name, id: data[1].value},
      {label: data[2].name, id: data[2].value},
      {label: data[3].name, id: data[3].value},
      {label: data[4].name, id: data[4].value},
      {label: data[5].name, id: data[5].value},
      {label: data[6].name, id: data[6].value},
      {label: data[7].name, id: data[7].value},
      {label: data[8].name, id: data[8].value},
      {label: data[9].name, id: data[9].value},
      {label: data[10].name, id: data[10].value},
      {label: data[11].name, id: data[11].value},
      {label: data[12].name, id: data[12].value},
      {label: data[13].name, id: data[13].value},
      {label: data[14].name, id: data[14].value},
      {label: data[15].name, id: data[15].value},
      {label: data[16].name, id: data[16].value},
      {label: data[17].name, id: data[17].value},
      {label: data[18].name, id: data[18].value},
      {label: data[19].name, id: data[19].value},
      {label: data[20].name, id: data[20].value},
      ]
      }, error => {        
        console.log('Failed while trying get Tags.' + error);
      });
  }

  onOptionSelected($event: Event): void {
    const value: any = $event;
    const value2:string= value
    var inputTemporal = document.createElement("textarea");
    inputTemporal.value = value2;
    document.body.appendChild(inputTemporal);
    inputTemporal.select();
    document.execCommand("copy");
    document.body.removeChild(inputTemporal);
  }

}
